import dynamic from 'next/dynamic';

export const components = {
    DIRECTES: dynamic(() => import(`./Directes`))
};
